import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72aad488"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "score-section" }
const _hoisted_2 = { class: "score-header" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_4 = { class: "score-details" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score-label" }, "Resume Score", -1))
const _hoisted_6 = { class: "score-description text-muted" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "score-content" }
const _hoisted_10 = { class: "breakdown-item" }
const _hoisted_11 = { class: "breakdown-label" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Keywords Match", -1))
const _hoisted_13 = { class: "breakdown-score" }
const _hoisted_14 = { class: "progress" }
const _hoisted_15 = { class: "breakdown-item" }
const _hoisted_16 = { class: "breakdown-label" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Experience Match", -1))
const _hoisted_18 = { class: "breakdown-score" }
const _hoisted_19 = { class: "progress" }
const _hoisted_20 = { class: "breakdown-item" }
const _hoisted_21 = { class: "breakdown-label" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Skills Match", -1))
const _hoisted_23 = { class: "breakdown-score" }
const _hoisted_24 = { class: "progress" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeScorePanel',
  props: {
    score: {},
    keywordsScore: {},
    experienceScore: {},
    skillsScore: {},
    updating: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isExpanded = ref(false);

function toggleExpand() {
  isExpanded.value = !isExpanded.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["optimization-score", { expanded: isExpanded.value }]),
      onClick: toggleExpand
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["score-circle", { 'updating-score': _ctx.updating }]),
          style: _normalizeStyle({ '--score': _ctx.score })
        }, [
          (_ctx.updating)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.score) + "%", 1)
        ], 6),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_ctx.updating)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Updating score..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "Based on job requirements"))
          ])
        ]),
        _createElementVNode("i", {
          class: _normalizeClass(["bi", isExpanded.value ? 'bi-chevron-up' : 'bi-chevron-down'])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.keywordsScore) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "progress-bar",
              role: "progressbar",
              style: _normalizeStyle({ width: _ctx.keywordsScore + '%' })
            }, null, 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.experienceScore) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "progress-bar",
              role: "progressbar",
              style: _normalizeStyle({ width: _ctx.experienceScore + '%' })
            }, null, 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.skillsScore) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              class: "progress-bar",
              role: "progressbar",
              style: _normalizeStyle({ width: _ctx.skillsScore + '%' })
            }, null, 4)
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})